const motogodziny = { t: 'Motogodziny', type: 'range', name: 'motogodziny', unit: 'h', hint: { url: '/motohours' }, small: true }
export default motogodziny